import React, { useState, useEffect } from 'react';
import { generateImageSource } from '../../../../utils/generateImageSource';

const JobPostingNotification = ({ visible, title, text, color }) => {
  const [show, setShow] = useState(false);

  useEffect(() => {

    if (show !== visible) {
      setShow(visible);
    }
  }, [visible]);

  if (!show) {
    return null;
  }

  let borderColor;
  let icon;

  if (color === 'red') {
    borderColor = '6px solid #FF002E';
    icon = (
      <img
        className="job-posting-notification__success-icon"
        src={generateImageSource('/images/v1/path-to-pro/x-icon-red.svg')}
      />
    );
  } else {
    // default case is success green
    borderColor = '6px solid #00AE4D';
    icon = (
      <img
        className="job-posting-notification__success-icon"
        src={generateImageSource('/images/v1/path-to-pro/success_icon_green.svg')}
      />
    );
  }

  return (
    <div
      className="job-posting-notification__root"
      data-testid="job-posting-notification"
      style={{ borderLeft: borderColor }}
    >
      <button
        aria-label="close"
        className="job-posting-notification__close-button"
        onClick={() => setShow(false)}
        data-testid="job-posting-notification__close-button"
      >
        <img src={generateImageSource('/images/v1/path-to-pro/close_icon_black.svg')} />
      </button>
      <div
        className="job-posting-notification__header"
        data-testid="job-posting-notification__header"
      >
        {icon}
        <span>{title}</span>
      </div>
      <div className="job-posting-notification__text" data-testid="job-posting-notification__text">
        <span>{text}</span>
      </div>
    </div>
  );
};

export default JobPostingNotification;
